import { defineNuxtPlugin } from '#app';
import Tooltip from 'primevue/tooltip';

export default defineNuxtPlugin((nuxtApp) => {
    // Register tooltip directive with configuration
    nuxtApp.vueApp.directive('tooltip', {
        ...Tooltip,
        mounted(el, binding) {
            // Set default options
            const options = typeof binding.value === 'string' 
                ? { value: binding.value, appendTo: 'body' }
                : { ...binding.value, appendTo: binding.value?.appendTo || 'body' };
            
            // Call original mounted with modified options
            if (Tooltip.mounted) {
                Tooltip.mounted(el, { ...binding, value: options }, null as any, null as any);
            }
        },
        updated: Tooltip.updated,
        unmounted: Tooltip.unmounted
    });

    return {
        provide: {
            tooltip: Tooltip,
        },
    };
});
